import React from "react";
import styled from "styled-components";

function CustomButton({
  width,
  height,
  background,
  title,
  color,
  border,
  handle,
  borderRadius,
  disabled,
}) {
  return (
    <Button
      disabled={disabled}
      onClick={handle}
      width={width}
      height={height}
      background={background}
      color={color}
      border={border}
      borderRadius={borderRadius}
    >
      {title}
    </Button>
  );
}

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${(props) => (props.width ? props.width : "129px")};
  height: ${(props) => (props.height ? props.height : "40px")};

  border: none;
  ${(props) => props.border && "border: solid 1px var(--darkBlue);"}

  padding: 0px 20px;
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : "20px"};

  cursor: pointer;
  background-color: ${(props) =>
    props.background ? props.background : "var(--darkBlue)"};

  color: ${(props) => (props.color ? props.color : "var(--white)")};
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export default CustomButton;
